export default "__VITE_ASSET__4BT2lqZV__"